<template>
  <div :class="settingPanel" v-if="showChannelSetting">
    <div class="channel-panel">
      <span class="channel-status">{{ currChannel.channelName }}</span>
      <el-dropdown @command="changeChannel" trigger="click">
        <span class="el-dropdown-link">
          切换频道<i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
        <el-dropdown-menu class="channel-item-panel" slot="dropdown">
          <el-dropdown-item
            class="channel-item"
            v-for="(value, index) in channelArr"
            :command="value"
            :key="index"
          >
            {{ value.channelName }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import industryApi from "../../api/industryApi";

  export default {
    name: 'channelSetting',
    data() {
      return {
        currChannel: {},
        showChannelSetting: false
      }
    },
    watch: {
      $route() {
        this.showChannelSetting = this.$route.meta.showChannelSetting
      },
      channelType(val) {
        let filteredList = this.channelArr.filter(s => s.id == val);
        let currentChannel = null
        if (filteredList.length > 0) {
          currentChannel = filteredList[0];
        } else {
          currentChannel = this.channelArr[0];
        }
        if (currentChannel) {
          this.changeChannel(currentChannel);
        }
      }
    },
    mounted() {
      if (this.channelArr.length > 0) {
        return;
      }
      this.getChannelList(() => {
        this.showChannelSetting = this.$route.meta.showChannelSetting
        this.$router.onReady(() => {
          const { name, query } = this.$route
          let filteredList = this.channelArr.filter(s => s.id == query.currKey);
          let currentChannel = null
          if (filteredList.length > 0) {
            currentChannel = filteredList[0];
          } else {
            currentChannel = this.channelArr[0];
          }
          if (currentChannel) {
            this.changeChannel(currentChannel);
          }
        })
      });
    },
    computed: {
      ...mapGetters([
        'channelType',
        'channelArr'
      ]),
      settingPanel() {
        return this.$store.state.app.device === 'mobile' ? 'mobile-channel-setting' : 'channel-setting'
      }
    },
    methods: {
      /**
       * @param {Object} obj 当前选中的值
       * @description 修改频道函数
       * **/
      changeChannel(obj) {
        this.currChannel = obj
        this.$store.commit('industry/SET_CHANNEL', obj)
        let { name, query } = this.$route;
        if (query && query.currKey == obj.id) {
          return;
        }
        if (name == 'industry') {
          this.$router.push({
            name: 'industry',
            query: { currKey: obj.id }
          })
        }
      },
      getChannelList(cb) {
        industryApi.channelList().then(res => {
          if (res.code === 200) {
            this.$store.commit("industry/SET_CHANNEL_ARR", res.data);
            cb();
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mobile-channel-setting {

    .channel-panel {
      display: flex;
      text-align: center;
      height: p2r(20px);

      .channel-status {
        width: auto;
        height: p2r(20px);
        font-size: p2r(18px) !important;
      }

      .channel-btn {
        color: $bloodRed;
      }

      .channel-status, .channel-btn {
        line-height: p2r(20px);
        font-size: p2r(10px);
      }

      /deep/ .el-dropdown {
        width: p2r(80px);

        /deep/ .el-dropdown-link {
          display: inline-block;
          font-size: p2r(10px);
          color: $bloodRed;
          cursor: pointer;
          height: p2r(20px);
          line-height: p2r(20px);
        }
      }
    }
  }

  .channel-setting {

    .channel-panel {
      display: flex;
      text-align: center;

      .channel-status {
        color: #474546;
      }

      .channel-btn {
        color: $bloodRed;
      }

      .channel-status, .channel-btn {
        line-height: p2r(32px);
        font-size: p2r(23px);
      }

      /deep/ .el-dropdown {
        width: p2r(100px);
        font-size: 12px;

        /deep/ .el-dropdown-link {
          display: inline-block;
          color: $bloodRed;
          cursor: pointer;
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }

  .channel-item-panel {
    padding: p2r(12px) 0;

    .channel-item {
      height: 2em;
      line-height: 2em;
      color: #999;
      cursor: pointer;
      padding: 0 p2r(12px);
      font-size: p2r(16px);

      &:hover {
        color: $bloodRed;
        background: rgba(237, 232, 232, 1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/headerComp/channelSetting.vue